var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.6875H18.9375V19.5C18.9375 21.2569 17.5069 22.6875 15.75 22.6875H8.25C6.49312 22.6875 5.0625 21.2569 5.0625 19.5V9.75C5.0625 9.43875 4.81125 9.1875 4.5 9.1875C4.18875 9.1875 3.9375 9.43875 3.9375 9.75V19.5C3.9375 21.8775 5.8725 23.8125 8.25 23.8125H15.75C18.1275 23.8125 20.0625 21.8775 20.0625 19.5V7.62C21.135 7.365 21.9375 6.40125 21.9375 5.25C21.9375 3.90562 20.8444 2.8125 19.5 2.8125H4.5C3.15562 2.8125 2.0625 3.90562 2.0625 5.25C2.0625 6.59438 3.15562 7.6875 4.5 7.6875ZM4.5 3.9375H19.5C20.2237 3.9375 20.8125 4.52625 20.8125 5.25C20.8125 5.97375 20.2237 6.5625 19.5 6.5625H4.5C3.77625 6.5625 3.1875 5.97375 3.1875 5.25C3.1875 4.52625 3.77625 3.9375 4.5 3.9375Z",
    fill: "#85909F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 1.3125H14.8125C15.1238 1.3125 15.375 1.06125 15.375 0.75C15.375 0.43875 15.1238 0.1875 14.8125 0.1875H9.1875C8.87625 0.1875 8.625 0.43875 8.625 0.75C8.625 1.06125 8.87625 1.3125 9.1875 1.3125Z",
    fill: "#85909F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 19.5V10.875C9.9375 10.5637 9.68625 10.3125 9.375 10.3125C9.06375 10.3125 8.8125 10.5637 8.8125 10.875V19.5C8.8125 19.8112 9.06375 20.0625 9.375 20.0625C9.68625 20.0625 9.9375 19.8112 9.9375 19.5Z",
    fill: "#85909F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 19.5V10.875C15.1875 10.5637 14.9362 10.3125 14.625 10.3125C14.3137 10.3125 14.0625 10.5637 14.0625 10.875V19.5C14.0625 19.8112 14.3137 20.0625 14.625 20.0625C14.9362 20.0625 15.1875 19.8112 15.1875 19.5Z",
    fill: "#85909F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.66470c2e4e0c954ca739c9f18bd930c4.svg";
export { ForwardRef as ReactComponent };